import React from 'react';

function AdditionalInfo({ about }) {
  if (!about || !about.overview) {
    return null;
  }

  return (
    <div className="additional-content">
      <p>{about.overview}</p>
    </div>
  );
}

export default AdditionalInfo;
